interface CaseVideoProps {
 videoIndex: number
 add?: string
 video: string
 className?: string
}

export function CaseVideo({
 videoIndex,
 add,
 className,
 video
}: CaseVideoProps) {
 return (
  <div className={`${add} ${className}`}>
   <iframe
    className="w-full"
    src={`https://www.youtube.com/embed/${video}?showinfo=1&rel=0&controls=0`}
    allow="autoplay"
    title={`Vídeo ${videoIndex + 1}`}
    loading="lazy"
   ></iframe>
  </div>
 )
}
